import { Link } from "react-router-dom";
import { MapPin, Bed, Maximize, Euro } from "lucide-react";
import { Badge } from "./ui/badge";
import FavoriteButton from "./FavoriteButton";

const PropertyCard = ({ listing, index }) => {
  const placeholderImages = [
    "https://images.unsplash.com/photo-1663756915304-40b7eda63e41?crop=entropy&cs=srgb&fm=jpg&w=400",
    "https://images.unsplash.com/photo-1663756915301-2ba688e078cf?crop=entropy&cs=srgb&fm=jpg&w=400",
    "https://images.unsplash.com/photo-1627141234469-24711efb373c?crop=entropy&cs=srgb&fm=jpg&w=400"
  ];

  const imageUrl = listing.images?.[0] || placeholderImages[index % placeholderImages.length];
  
  const isUnclaimed = listing.status === "detected" || listing.status === "invited";

  const getPropertyTypeLabel = (type) => {
    const types = {
      apartament: "Apartament",
      casa: "Casă",
      teren: "Teren",
      spatiu_comercial: "Spațiu comercial"
    };
    return types[type] || type;
  };

  return (
    <Link to={`/proprietate/${listing.id}`}>
      <article
        data-testid={`property-card-${listing.id}`}
        className="property-card bg-white rounded-2xl overflow-hidden border border-stone-100 card-shadow card-shadow-hover animate-fade-in"
        style={{ animationDelay: `${index * 0.05}s` }}
      >
        {/* Image */}
        <div className="relative h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={listing.title}
            className="property-image w-full h-full object-cover"
            loading="lazy"
          />
          
          {/* Price Badge */}
          <div className="absolute top-3 left-3">
            <div className="price-badge flex items-center gap-1">
              <Euro className="w-4 h-4" />
              {listing.price.toLocaleString('ro-RO')}
            </div>
          </div>

          {/* Favorite Button */}
          <div className="absolute top-3 right-3">
            {isUnclaimed ? (
              <Badge className="bg-amber-500 text-white">
                De revendicat
              </Badge>
            ) : (
              <FavoriteButton listingId={listing.id} size="small" />
            )}
          </div>

          {/* Property Type */}
          <div className="absolute bottom-3 left-3">
            <Badge variant="secondary" className="bg-white/90 backdrop-blur text-stone-700">
              {getPropertyTypeLabel(listing.property_type)}
            </Badge>
          </div>
        </div>

        {/* Content */}
        <div className="p-4">
          <h3 className="font-['Outfit'] font-semibold text-lg text-stone-900 mb-2 line-clamp-1">
            {listing.title}
          </h3>
          
          <div className="flex items-center gap-1 text-stone-500 text-sm mb-3">
            <MapPin className="w-4 h-4 flex-shrink-0" />
            <span className="truncate">{listing.zone}, {listing.city}</span>
          </div>

          {/* Stats */}
          <div className="flex items-center gap-4 text-stone-600">
            <div className="flex items-center gap-1">
              <Bed className="w-4 h-4 text-stone-400" />
              <span className="text-sm">{listing.rooms} cam</span>
            </div>
            <div className="flex items-center gap-1">
              <Maximize className="w-4 h-4 text-stone-400" />
              <span className="text-sm">{listing.surface} mp</span>
            </div>
            <div className="ml-auto text-sm text-stone-400">
              {Math.round(listing.price / listing.surface)} €/mp
            </div>
          </div>

          {/* Source indicator */}
          <div className="mt-3 pt-3 border-t border-stone-100 flex items-center justify-between">
            <span className="text-xs text-stone-400 uppercase">
              via {listing.source}
            </span>
            {isUnclaimed && (
              <span className="text-xs text-amber-600 font-medium">
                Disponibil pentru revendicare
              </span>
            )}
          </div>
        </div>
      </article>
    </Link>
  );
};

export default PropertyCard;
